import React from 'react';
import { CheckCircle2, BookOpen, Calendar, Coffee, Footprints, Pill } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-[#C9A84C]" data-id="element-156" />,
    title: 'El eBook Principal',
    desc: '"Rodillas Jóvenes: El Protocolo de 21 Días" (PDF descargable al instante).'
  }, {
    icon: <Calendar className="w-8 h-8 text-[#C9A84C]" data-id="element-157" />,
    title: 'Calendario de Implementación',
    desc: 'Paso a paso detallado para las Semanas 1 a 3. Sin adivinanzas.'
  }, {
    icon: <Coffee className="w-8 h-8 text-[#C9A84C]" data-id="element-158" />,
    title: 'Guía de "Alimentos Sagrados"',
    desc: 'Cómo desinflamar tus articulaciones usando ingredientes de la cocina latina.'
  }, {
    icon: <Footprints className="w-8 h-8 text-[#C9A84C]" data-id="element-159" />,
    title: 'El Protocolo de Calzado',
    desc: 'Cómo elegir zapatos en USA que realmente protejan tu marcha y columna.'
  }, {
    icon: <Pill className="w-8 h-8 text-[#C9A84C]" data-id="element-160" />,
    title: 'Lista de Suplementos Reales',
    desc: 'Lo que sí funciona (y puedes comprar en Walgreens/CVS) y cuáles evitar.'
  }];
  return <section className="py-20 bg-[#FAF7F2]" data-id="element-161">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-162">
        <div className="mb-12 rounded-2xl overflow-hidden shadow-lg max-w-2xl mx-auto" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/3TJwGAVWF8yYKsEGaziBzc/section-97588.png" alt="Médicos Recomiendan el Protocolo para Rodillas Jóvenes" className="w-full h-auto object-cover" data-id="element-164" />
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-165">
          Todo Lo Que Obtienes Hoy
        </h2>

        <div className="space-y-6" data-id="element-166">
          {items.map((item, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-[#E8F0EC] flex flex-col sm:flex-row gap-6 items-start sm:items-center hover:shadow-md transition-shadow" data-id="element-167">
              <div className="bg-[#FAF7F2] p-4 rounded-xl flex-shrink-0" data-id="element-168">
                {item.icon}
              </div>
              <div className="flex-1" data-id="element-169">
                <h3 className="text-2xl font-bold text-[#1B5E5E] mb-2 flex items-center gap-2" data-id="element-170">
                  {item.title}
                </h3>
                <p className="text-lg text-gray-600" data-id="element-171">{item.desc}</p>
              </div>
              <div className="hidden sm:block flex-shrink-0" data-id="element-172">
                <CheckCircle2 className="w-8 h-8 text-green-500" data-id="element-173" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}